import { ReactElement } from 'react';

import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

type Props = {
  containerExclusionField: ReactElement;
};

export const ExcludedContainersSettingsContainer = ({
  containerExclusionField,
}: Props) => {
  const { title, description } = vpaSettingsConstants.excludedContainers;

  return (
    <VerticalSettingsForm title={title} description={description}>
      {containerExclusionField}
    </VerticalSettingsForm>
  );
};
